import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 27.8.",
  "description": "",
  "published": "2011-08-27T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-27-8/swizec/2294"],
  "categories": "Application programming interface, Foursquare, Health, Jet lag, Learning, Personal, Recreation, travel",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/08/Sleep-cycle1.gif",
        "alt": "Sleep-cycle",
        "title": "Sleep-cycle"
      }}></img></p>
    <p>{`Today I learned that `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Jet_lag",
        "title": "Jet lag"
      }}>{`jet lag`}</a>{` is a much uglier beast than I ever anticipated. I don't remember having this much trouble last time I came back from the US; perhaps because I wasn't there for as long and the different timezone didn't seep into my `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Circadian_rhythm",
        "title": "Circadian rhythm"
      }}>{`sleep cycle`}</a>{` as much? All week I've been getting up in the middle of the day and then being unable to fall asleep until insane morning hours (think 6 or 7am).`}</p>
    <p>{`This seems to throw my whole day into a tailspin, especially because the wakeup isn't exactly nice and the sleep doesn't leave me rested at all. As a result this whole week I've barely managed to stitch 30 productive hours together. Most of which came as the cram session for the Thursday exam. Sure hope this thing passes soon.`}</p>
    <p>{`Another thing I learned is that with the new OAuth2 `}<a parentName="p" {...{
        "href": "http://www.foursquare.com/",
        "title": "Foursquare"
      }}>{`Foursquare`}</a>{` API and teh awesomeness of `}<a parentName="p" {...{
        "href": "http://jquery.com/",
        "title": "JQuery"
      }}>{`jQuery`}</a>{` it is very `}<em parentName="p">{`very`}</em>{` simple to make a purely browser-side Foursquare client in javascript. This comes as a great breakthrough in the way everyone can develop web apps and I think is wroth some more exploration. The first thing I'm going to try is making the footer on my blog work again since it's been turned off because it couldn't handle the load.`}</p>
    <p>{`Anyone know of a ready-made library existing already?`}</p>
    <p>{`Of course making soem sort of distributed cache with minimal involvement from the server will be the real issue ... but definitely worth exploring.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.mycricket.com/community/cell-phone-info/checking-which-app-should-i-use"
        }}>{`Checking In: Which App Should I Use`}</a>{` (mycricket.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://shivasleeps.wordpress.com/2011/08/27/sleep-statistics-for-26-27-aug-fri/"
        }}>{`Sleep statistics for 26 - 27 Aug (Fri)`}</a>{` (shivasleeps.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://buddhavani.wordpress.com/2011/07/23/jet-lag/"
        }}>{`Jet Lag`}</a>{` (buddhavani.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=416ae825-a3af-4821-bd55-6ee9053854d3",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      